import Vue from 'vue'
export const bus = new Vue;
// showContextmenu标签页右键出现上下文选择
// bus.prototype.showContextmenu = false;


// WEBPACK FOOTER //
// ./src/bus.js